import React from "react";
import LeadsTableBody from "./LeadsTableBody";

/**
 * Wrapper for rendering Realestate Leads rows.
 * Reuses the shared LeadsTableBody but sets activeTab="Realestate Leads".
 */
function RealestateLeadsTable(props) {
  return <LeadsTableBody {...props} activeTab="Realestate Leads" />;
}

export default RealestateLeadsTable;
